import { useState } from 'react'
import { LuSearch } from 'react-icons/lu'
import api from '../services/api'
import './PortalTools.css'

function CoelsaConsultPage() {
  const [coelsaId, setCoelsaId] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [result, setResult] = useState(null)

  const handleSearch = async (e) => {
    e.preventDefault()
    const id = coelsaId.trim()
    if (!id) {
      setError('Ingresá el ID COELSA')
      return
    }
    setLoading(true)
    setError('')
    setResult(null)
    try {
      const response = await api.get('/coelsa/consult', { params: { id } })
      setResult(response.data?.data || null)
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo consultar el ID COELSA')
    } finally {
      setLoading(false)
    }
  }

  const op = result?.data?.operacion
  const detalle = op?.detalle
  const comprador = op?.comprador
  const vendedor = op?.vendedor

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Consulta Coelsa</h1>
        <p>Consultá una operación por su ID COELSA.</p>
      </div>

      <form className="tool-card" onSubmit={handleSearch}>
        <label>ID COELSA</label>
        <div className="tool-row">
          <input
            className="form-control"
            value={coelsaId}
            onChange={(e) => setCoelsaId(e.target.value)}
            placeholder="ORDDELENBMPXORV7EYNM1Y330"
          />
          <button className="btn-primary" disabled={loading}>
            <LuSearch /> {loading ? 'Consultando...' : 'Consultar'}
          </button>
        </div>
      </form>

      {error && <div className="alert alert-error">{error}</div>}

      {op && (
        <div className="tool-card">
          <div className="tool-kpis">
            <div><span>Código</span><strong>{result?.code || op.estado?.codigo || '-'}</strong></div>
            <div><span>Estado</span><strong>{op.estado?.codigo || '-'}</strong></div>
            <div><span>Importe</span><strong>{detalle?.importe != null ? `$ ${Number(detalle.importe).toLocaleString('es-AR')}` : '-'}</strong></div>
            <div><span>Tipo</span><strong>{op.tipo || '-'}</strong></div>
          </div>
          <p className="tool-desc">{op.estado?.descripcion || result?.description}</p>
          <div className="tool-grid">
            <section>
              <h3>Operación</h3>
              <p><b>Concepto:</b> {detalle?.concepto || '-'}</p>
              <p><b>Descripción:</b> {detalle?.descripcion || '-'}</p>
              <p><b>Fecha:</b> {detalle?.fecha || '-'}</p>
              <p><b>Vencimiento:</b> {detalle?.fechaExpiracion || '-'}</p>
              <p><b>Id original:</b> {detalle?.idOperacionOriginal || '-'}</p>
            </section>
            <section>
              <h3>Comprador</h3>
              <p><b>Titular:</b> {comprador?.titular || '-'}</p>
              <p><b>CUIT:</b> {comprador?.cuit || '-'}</p>
              <p><b>CBU/CVU:</b> {comprador?.cbu || '-'}</p>
              <p><b>Banco:</b> {comprador?.banco || '-'} · Suc. {comprador?.sucursal || '-'}</p>
            </section>
            <section>
              <h3>Vendedor</h3>
              <p><b>Titular:</b> {vendedor?.titular || '-'}</p>
              <p><b>CUIT:</b> {vendedor?.cuit || '-'}</p>
              <p><b>CBU/CVU:</b> {vendedor?.cbu || '-'}</p>
              <p><b>Endpoint:</b> {vendedor?.endpointId || '-'}</p>
            </section>
          </div>
        </div>
      )}
    </div>
  )
}

export default CoelsaConsultPage
